module.exports = __webpack_public_path__ + "static/media/11NEPAD12.f9d545ff.jpg";